// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__M-FUL","text":"loader_text__eatvy","anim":"loader_anim__1Km7t","dotMove":"loader_dotMove__CZv0H","move":"loader_move__H6v-n"};